import { IApplicationState } from '../../types/redux';
import { getActiveRatingFilters } from './getActiveRatingFilters';

export function getActiveRatingFiltersValues(state: IApplicationState): number[] {
  const active = getActiveRatingFilters(state);

  return active.map(item => item.reviewRate);
}
